// extracted by mini-css-extract-plugin
export default {"wrapper":"EGyX2A3_HTjA8gHcNGIw","big":"GeQ_GE7Jof8pldBcf6v_","dropdown":"ZoBtmA9n5md853Btk0ru","not_found_content_description":"o3YsRoaRHrxAIJBhtpKd"};